export default {
  namespaced: true,

  state: {
    editMode: false,
    favouriteInitiated: false,
    favourites: [],
  },

  mutations: {
    setFavourite(state, fav) {
      state.favouriteInitiated = true;
      state.favourites = fav;

    },
    addFavourite(state, fav) {
      const {
        routeid, routedir, stopseq, stopid, stopc, fare, subarea,
        routec, startc, destinc
      } = fav;

      // update store
      state.favourites = [
        ...state.favourites,
        {
          routeid, routedir, stopseq, stopid, stopc, fare, subarea,
          routec, startc, destinc
        },
      ];

      // update local storage
      localStorage.setItem('favourite', JSON.stringify(state.favourites));
    },
    removeFavourite(state, fav) {
      // update store
      const newFavList = state.favourites.reduce((acc, cur) => {
        if (
          cur.routeid !== fav.routeid ||
          cur.routedir !== fav.routedir ||
          cur.stopseq !== fav.stopseq
        ) {
          acc.push(cur);

        }

        return acc;
      }, []);

      state.favourites = newFavList;

      // update local storage
      localStorage.setItem('favourite', JSON.stringify(state.favourites));
    },
    toggleEditMode(state, editMode) {
      console.log('favourite model, toggle edit mode', editMode);

      state.editMode = !state.editMode;
    },
  },

  actions: {
    getFavouriteList({commit}) {
      const json = JSON.parse(localStorage.getItem('favourite'));

      commit('setFavourite', json ? json : []);
    },

    addFavourite({commit}, stopDetails) {
      commit('addFavourite', stopDetails);

    },

    removeFavourite({commit}, stopDetails) {
      commit('removeFavourite', stopDetails);

    },


  },

  getters: {
    checkFavourite: (state) => (stop) => {
      return state.favourites.find(x => {
        console.log(x, stop);

        return (
          x.routeid === stop.routeid &&
          x.routedir === stop.routedir &&
          x.stopseq === stop.stopseq
        );
      });

    }
  },


}
